import { useState, useEffect } from 'react';

const useShortcutKeys = () => {
  const [keyConfig, setKeyConfig] = useState<{ altKey: string; ctrlKey: string }>({
    altKey: 'unknown',
    ctrlKey: 'unknown',
  });

  useEffect(() => {
    const detectOS = () => {
      const platform = navigator.platform.toLowerCase();
      const userAgent = navigator.userAgent.toLowerCase();

      if (platform.includes('mac') || userAgent.includes('macintosh')) {
        console.log("Detected Mac OS");
        return { altKey: 'Option', ctrlKey: '⌘' };
      } else if (platform.includes('win') || userAgent.includes('windows')) {
        console.log("Detected Windows OS");
        return { altKey: 'Alt', ctrlKey: 'Ctrl' };
      } else {
        return { altKey: 'unknown', ctrlKey: 'unknown' };
      }
    };
    setKeyConfig(detectOS());
  }, []);

  const positiveCta = `(${keyConfig.ctrlKey} + A)`;
  const negativeCta = `(${keyConfig.ctrlKey} + X)`;

  return { positiveCta, negativeCta, ctrlKey: keyConfig.ctrlKey, altKey: keyConfig.altKey };
};

export default useShortcutKeys;